<div class="not-found-container">
  <h1>404 - Not Found</h1>
  <p>
    The flight school or operator you are looking for does not exist or is not
    available.
  </p>
</div>
